import { css, type Theme } from '@emotion/react';
import styled from '@emotion/styled';

import { mq } from '@hrworks/design-system/utilities';

const componentConfig = (theme: Theme) => ({
  sidebar: {
    horizontalPadding: 20,
    width: 255,
  },
  header: {
    height: 70,
    logoWidth: 120,
  },
  mobileHeaderBackgroundColor: theme.eclipseTier2Color.background.nav.default,
});

const globalStyles = (theme: Theme) =>
  css({
    body: {
      backgroundColor: componentConfig(theme).mobileHeaderBackgroundColor,
    },
  });

const LayoutContainer = styled.div<{ isSidebarCollapsed: boolean }>(({ theme, isSidebarCollapsed }) => {
  const { sidebar, header } = componentConfig(theme);

  return {
    display: 'grid',
    gridTemplateAreas: `
    'header  header'
    'sidebar content'
  `,
    gridTemplateColumns: `${sidebar.width}px 1fr`,
    ...(isSidebarCollapsed && {
      gridTemplateColumns: '0 1fr',
    }),
    gridTemplateRows: `${header.height}px 1fr`,
    [mq.conditionalTransition]: {
      transition: `grid-template-columns ${theme.variables.animationDuration.long}`,
    },

    width: '100%',
    height: '100%',
    backgroundColor: theme.eclipseTier2Color.surface.base,

    [mq.isSmallDevice]: {
      gridTemplateAreas: `
      'header'
      'content'
    `,
      gridTemplateColumns: '100%',
    },
  };
});

export const S = {
  componentConfig,
  globalStyles,
  LayoutContainer,
} as const;
